import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import RouteCalculator from '../views/RouteCalculator.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/debug',
    name: 'Debug',
    component: Home,
    props: {
      debug: true
    }
  },
  {
    path: '/calculate',
    name: 'Calculate',
    component: RouteCalculator
  }
]

const router = new VueRouter({
  routes
})

export default router
